<template>
	<div>
		<ApprovalChecks
			v-if="agpsApprovalCheck"
			:item="ps"
			item_type="agps_approval"
			:roles_needed="requiredRoles"
			@onChange="reloadInfo"/>
		<v-btn
			v-else-if="isUserIto"
			color="success"
			class="flex-grow-1"
			x-small
			:loading="loading"
			@click.stop="startApprove">
			<p class="mb-0 white--text">Aprobar</p>
		</v-btn>
	</div>
</template>

<script>
import ApprovalChecks from '@/components/Globals/Helpers/ApprovalChecks'

export default {
	name: 'AGPSApprovalClosure',
	components: {
		ApprovalChecks
	},
	props: {
		ps: {
			type: Object,
			required: true
		},
		isUserIto: {
			type: Boolean,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		agpsApprovalCheck() {
			return this.selectedProject.closure_config.find(
				config => config.item_type === 5 && config.use_advanced_closure
			)
		},
		requiredRoles() {
			return this.agpsApprovalCheck ? this.agpsApprovalCheck.advanced_closure_profiles : []
		}
	},
	methods: {
		reloadInfo() {
			this.$emit('onChange')
		},
		startApprove() {
			this.$emit('startApprove', this.ps)
		}
	}
}
</script>

<style></style>
